// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********* PRIMARY ***********/
/********* DARK ***********/
/********* LIGHT ***********/
/********* ACCENT ALTERNATES ***********/
/********* STATUS ***********/
.font--14, .input--label {
  font-weight: 700;
  font-size: 14px;
  line-height: 120%;
}

.menu-item--wrapper {
  width: 100%;
  padding: 10px;
  cursor: pointer;
}

.font--16 {
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
}

.input--label {
  color: #111827;
  margin-bottom: 12px;
}

.inputs__body {
  margin-top: 30px;
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  justify-content: center;
}

.four-col {
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 20px;
}

.input--select {
  display: flex;
  flex-direction: column;
  z-index: 998;
}

.label-info {
  display: flex;
  align-items: flex-start;
}

.input-element {
  min-width: 100%;
  position: relative;
}

.arrow-down, .arrow-up::before,
.arrow-up {
  cursor: pointer;
}

.arrow-down::before, .arrow-up::before {
  content: " ";
  position: absolute;
  width: 8px;
  height: 8px;
  top: calc(50% - 3px);
  right: 20px;
  border: 1.5px solid;
  transform: rotate(45deg) translateY(-50%);
  border-color: transparent black black transparent;
}

.right-icon {
  position: absolute;
  right: 10px;
  top: calc(50% - 14px);
}
.right-icon button {
  background-color: transparent;
  color: rgb(0, 116, 0);
  font-size: 1.25rem;
}
.right-icon button:active {
  transform: scale(0.9);
}

.arrow-up::before {
  border-color: black transparent transparent black !important;
}

.select--text, .select--button {
  box-sizing: border-box;
  padding: 13px 32px 13px 16px;
  background: #ffffff;
  border: 1px solid #77777a;
  border-radius: 8px;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

ul li {
  list-style: none;
  padding: 10px;
  border-bottom: 1px solid;
}

ul {
  margin: 0;
  padding: 0;
}

.drop-down--icon {
  background: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>") no-repeat;
  background-position: calc(100% - 0.75rem) center !important;
}

.options {
  border-radius: 4px;
  margin-top: 10px;
  background-color: #ffffff;
  height: fit-content;
  opacity: 0;
  transition: transform 0.5s ease-in-out;
  overflow-y: auto;
  z-index: -999;
  width: fit-content;
  position: absolute;
  display: none;
  box-shadow: 0 2px 2px -3px rgba(0, 0, 0, 0.2), 0 6px 8px 1px rgba(0, 0, 0, 0.1411764706), 0 3px 12px 1px rgba(0, 0, 0, 0.1215686275);
  max-height: 280px;
}

.options.active {
  display: block;
  z-index: 999;
}

.menu-active {
  background-color: #f1f1f1;
}

.menu-focus {
  background-color: transparent;
}

.options.not-hover {
  position: static;
}

.arrow-up.not-hover::before {
  top: calc(50% - 5px);
}

.input--select input:focus {
  outline: none !important;
  border: 1px solid #0040dd !important;
  box-shadow: 0px 4px 4px rgba(179, 178, 177, 0.16) !important;
}

.asterisk {
  color: rgb(142, 0, 0);
  margin-left: 4px;
  font-weight: 600;
}

#options::-webkit-scrollbar {
  width: 8px;
}
#options::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #71758a;
}

.caret-color--transparent {
  caret-color: transparent;
}

.search--icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  cursor: pointer;
}

.select--button {
  display: block;
  height: 54px;
  text-align: start;
  font-size: 1rem;
  vertical-align: middle;
}
.select--button::before {
  content: attr(data-placeholder);
  color: #71758a;
}
.select--button:disabled {
  background-color: rgb(238, 238, 240);
  cursor: not-allowed;
  color: rgb(0, 0, 0);
}

.select--button:has(.indicator) {
  display: flex;
}

.input-element:has(.select--button:disabled) .dropdown--icon {
  cursor: not-allowed;
}

.custom-option {
  padding: 0;
}
.custom-option button {
  background-color: transparent;
  color: rgb(0, 64, 221);
  width: 100%;
  padding: 10px;
  margin: 0;
}
.custom-option:hover {
  text-decoration: underline;
}
.custom-option input {
  width: 100% !important;
}

.dropdown--overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background-color: transparent;
  z-index: 899;
  overflow: hidden;
}

.indicator {
  height: 10px;
  width: 80px;
  margin-left: 10px;
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/style/settings/_color.scss","webpack://./src/app/shared/components/drop-down/select/select.component.scss","webpack://./src/app/shared/components/drop-down/menu-item/menu-item.component.scss"],"names":[],"mappings":"AA4BA,8BAAA;AAMA,2BAAA;AAMA,4BAAA;AAOA,wCAAA;AAMA,6BAAA;ACnDA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;ACIF;;ADDA;EACE,WAAA;EAEA,aAAA;EACA,eAAA;ACGF;;ADAA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;ACGF;;ADAA;EAEE,cAAA;EACA,mBAAA;ACEF;;ADCA;EACE,gBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;ACEF;;ADCA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,SAAA;ACEF;;ADEA;EACE,aAAA;EACA,sBAAA;EAGA,YAAA;ACDF;;ADIA;EACE,aAAA;EACA,uBAAA;ACDF;;ADIA;EACE,eAAA;EACA,kBAAA;ACDF;;ADIA;;EAEE,eAAA;ACDF;;ADIA;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,mBAAA;EACA,yCAAA;EACA,iDAAA;ACDF;;ADIA;EACE,kBAAA;EACA,WAAA;EACA,qBAAA;ACDF;ADGE;EACE,6BAAA;EACA,qBD9BM;EC+BN,kBAAA;ACDJ;ADGI;EACE,qBAAA;ACDN;;ADOA;EAEE,4DAAA;ACLF;;ADQA;EACE,sBAAA;EACA,4BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;ACLF;;ADQA;EACE,gBAAA;EACA,aAAA;EACA,wBAAA;ACLF;;ADQA;EACE,SAAA;EACA,UAAA;ACLF;;ADQA;EACE,0NAAA;EACA,2DAAA;ACLF;;ADQA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,sCAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EAEA,oIAAA;EACA,iBAAA;ACNF;;ADSA;EACE,cAAA;EACA,YAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,gBAAA;ACNF;;ADSA;EACE,oBAAA;ACNF;;ADSA;EACE,wBAAA;EACA,oCAAA;EACA,4DAAA;ACNF;;ADSA;EACE,qBDzHM;EC0HN,gBAAA;EACA,gBAAA;ACNF;;ADUE;EACE,UAAA;ACPJ;ADUE;EACE,kBAAA;EACA,yBAAA;ACRJ;;ADYA;EACE,wBAAA;ACTF;;ADYA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;ACTF;;ADYA;EAGE,cAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;ACXF;ADeE;EACE,+BAAA;EACA,cAAA;ACbJ;ADgBE;EACE,oCD/KM;ECgLN,mBAAA;EACA,mBDpMI;AEsLR;;ADkBA;EACE,aAAA;ACfF;;ADmBE;EACE,mBAAA;AChBJ;;ADoBA;EACE,UAAA;ACjBF;ADmBE;EACE,6BAAA;EACA,sBDpNa;ECqNb,WAAA;EACA,aAAA;EACA,SAAA;ACjBJ;ADoBE;EACE,0BAAA;AClBJ;ADqBE;EACE,sBAAA;ACnBJ;;ADwBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;ACrBF;;ADwBA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;ACrBF","sourcesContent":["$gray-dark: rgb(232, 232, 232);\n$i: 0;\n$font-regular: Avenir-Book;\n$font-fallback: Helvetica, Arial, sans-serif;\n$font-heavy: Avenir-Heavy;\n// Missing from old color.scss\n$accordion-border: $gray-dark;\n\n// Adding new color family\n\n$i: 0;\n// $font-regular: Avenir-Book;\n$header-bold: 'PP Neue Machina Ultrabold';\n$header-regular: 'PP Neue Machina Regular';\n$header-italic: 'PP Neue Machina Italic';\n$font-regular: 'Helvetica Neue LT Std';\n$font-light: 'Helvetica Neue LT Std Light';\n$font-bold: 'Helvetica Neue LT Std Bold';\n$font-black: 'Helvetica Neue LT Std Black';\n$font-fallback: Helvetica, Arial, sans-serif;\n$gray-1: rgb(34, 34, 34);\n$gray-2: rgb(119, 119, 122);\n$gray-3: rgb(153, 153, 154);\n$gray-4: rgb(179, 178, 177);\n\n$white: rgb(255, 255, 255);\n$black: rgb(0, 0, 0);\n\n/********* PRIMARY ***********/\n$accent-primary: rgb(0, 64, 221);\n$accent-primary-alt: rgb(0, 74, 151);\n$secondary: rgb(38, 202, 211);\n$secondary-1: rgb(0, 153, 168);\n\n/********* DARK ***********/\n$dark-1: $black;\n$dark-2: rgb(17, 24, 39);\n$dark-3: rgb(119, 119, 122);\n$dark-4: rgb(203, 203, 203);\n\n/********* LIGHT ***********/\n$light-1: $white;\n$light-2: rgb(244, 244, 244);\n// $light-3: rgb(245, 245, 251);\n$light-3: #F9F9F9;\n$light-4: rgb(238, 238, 240);\n\n/********* ACCENT ALTERNATES ***********/\n$alternate-Accent-1: rgb(15, 99, 214);\n$alternate-Accent-2: rgb(0, 147, 201);\n$alternate-Accent-3: rgb(0, 155, 222);\n$alternate-Accent-4: rgb(238, 244, 250);\n\n/********* STATUS ***********/\n$error: rgb(142, 0, 0);\n$error-alt: rgb(221, 34, 37);\n$warning: rgb(122, 89, 0);\n$success: rgb(0, 116, 0);\n\n// Assigning color to element\n$body-bg: $white;\n$main-content-bg: $light-3;\n$error: $error;\n$success: $success;\n$warning: $warning;\n\n// Navigation\n$nav-bg: $white;\n$nav-text-inactive: $accent-primary;\n$nav-text-active: $accent-primary;\n$nav-link-active-bg: rgba($accent-primary, 0.15);\n$nav-link-active-highlight: $accent-primary;\n$nav-right-border: $dark-4;\n\n// Input\n$button-primary-text: $white;\n$button-primary-background: $accent-primary;\n$button-primary-hover-background: $alternate-Accent-1;\n$button-primary-active-background: $accent-primary-alt;\n\n$button-secondary-text: $dark-2;\n$button-secondary-background: $white;\n$button-secondary-border: $dark-2;\n$button-secondary-hover-textColor: $alternate-Accent-1;\n$button-secondary-active-textColor: $accent-primary;\n$button-secondary-active-border: $accent-primary;\n\n$button-error-text: $white;\n$button-error-background: $error;\n$button-error-hover-background: $error-alt;\n\n$button-error-active-textColor: $accent-primary;\n$button-error-active-border: $accent-primary;\n\n$text-link-text: $accent-primary;\n\n","@import '/src/style/settings/color';\n\n.font--14 {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 120%;\n}\n\n.menu-item--wrapper {\n  width: 100%;\n  // border-bottom: 1px solid  rgb(221, 225, 226);\n  padding: 10px;\n  cursor: pointer;\n}\n\n.font--16 {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 120%;\n}\n\n.input--label {\n  @extend .font--14;\n  color: #111827;\n  margin-bottom: 12px;\n}\n\n.inputs__body {\n  margin-top: 30px;\n  display: flex;\n  gap: 30px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.four-col {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  gap: 20px;\n  // margin-bottom: 40px;\n}\n\n.input--select {\n  display: flex;\n  flex-direction: column;\n  //   min-width: 256px;\n  // position: relative;\n  z-index: 998;\n}\n\n.label-info {\n  display: flex;\n  align-items: flex-start;\n}\n\n.input-element {\n  min-width: 100%;\n  position: relative;\n}\n\n.arrow-down,\n.arrow-up {\n  cursor: pointer;\n}\n\n.arrow-down::before {\n  content: ' ';\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  top: calc(50% - 3px);\n  right: 20px;\n  border: 1.5px solid;\n  transform: rotate(45deg) translateY(-50%);\n  border-color: transparent black black transparent;\n}\n\n.right-icon {\n  position: absolute;\n  right: 10px;\n  top: calc(50% - 14px);\n\n  button {\n    background-color: transparent;\n    color: $success;\n    font-size: 1.25rem;\n\n    &:active {\n      transform: scale(0.9);\n    }\n  }\n\n}\n\n.arrow-up::before {\n  @extend .arrow-down;\n  border-color: black transparent transparent black !important;\n}\n\n.select--text {\n  box-sizing: border-box;\n  padding: 13px 32px 13px 16px;\n  background: #ffffff;\n  border: 1px solid #77777a;\n  border-radius: 8px;\n  width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\nul li {\n  list-style: none;\n  padding: 10px;\n  border-bottom: 1px solid;\n}\n\nul {\n  margin: 0;\n  padding: 0;\n}\n\n.drop-down--icon {\n  background: url(\"data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\") no-repeat;\n  background-position: calc(100% - 0.75rem) center !important;\n}\n\n.options {\n  border-radius: 4px;\n  margin-top: 10px;\n  background-color: #ffffff;\n  height: fit-content;\n  opacity: 0;\n  transition: transform 0.5s ease-in-out;\n  overflow-y: auto;\n  z-index: -999;\n  width: fit-content;\n  position: absolute;\n  display: none;\n  // top: 0;\n  box-shadow: 0 2px 2px -3px #0003, 0 6px 8px 1px #00000024, 0 3px 12px 1px #0000001f;\n  max-height: 280px;\n}\n\n.options.active {\n  display: block;\n  z-index: 999;\n}\n\n.menu-active {\n  background-color: #f1f1f1;\n}\n\n.menu-focus {\n  background-color: transparent;\n}\n\n.options.not-hover {\n  position: static;\n}\n\n.arrow-up.not-hover::before {\n  top: calc(50% - 5px);\n}\n\n.input--select input:focus {\n  outline: none !important;\n  border: 1px solid #0040dd !important;\n  box-shadow: 0px 4px 4px rgba(179, 178, 177, 0.16) !important;\n}\n\n.asterisk {\n  color: $error;\n  margin-left: 4px;\n  font-weight: 600;\n}\n\n#options {\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 4px;\n    background-color: #71758a;\n  }\n}\n\n.caret-color--transparent {\n  caret-color: transparent;\n}\n\n.search--icon {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 20px;\n  cursor: pointer;\n}\n\n.select--button {\n\n  @extend .select--text;\n  display: block;\n  height: 54px;\n  text-align: start;\n  font-size: 1rem;\n  vertical-align: middle;\n  // width: 240px;\n  // margin-top: 3px;\n\n  &::before {\n    content: attr(data-placeholder);\n    color: #71758a;\n  }\n\n  &:disabled {\n    background-color: $light-4;\n    cursor: not-allowed;\n    color: $black;\n  }\n}\n\n.select--button:has(.indicator) {\n  display: flex;\n}\n\n.input-element:has(.select--button:disabled) {\n  .dropdown--icon {\n    cursor: not-allowed;\n  }\n}\n\n.custom-option {\n  padding: 0;\n\n  button {\n    background-color: transparent;\n    color: $accent-primary;\n    width: 100%;\n    padding: 10px;\n    margin: 0;\n  }\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  input {\n    width: 100% !important;\n  }\n}\n\n\n.dropdown--overlay {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n  background-color: transparent;\n  z-index: 899;\n  overflow: hidden;\n}\n\n.indicator {\n  height: 10px;\n  width: 80px;\n  margin-left: 10px;\n  border-radius: 5px;\n}","/********* PRIMARY ***********/\n/********* DARK ***********/\n/********* LIGHT ***********/\n/********* ACCENT ALTERNATES ***********/\n/********* STATUS ***********/\n.font--14, .input--label {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 120%;\n}\n\n.menu-item--wrapper {\n  width: 100%;\n  padding: 10px;\n  cursor: pointer;\n}\n\n.font--16 {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 120%;\n}\n\n.input--label {\n  color: #111827;\n  margin-bottom: 12px;\n}\n\n.inputs__body {\n  margin-top: 30px;\n  display: flex;\n  gap: 30px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.four-col {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  gap: 20px;\n}\n\n.input--select {\n  display: flex;\n  flex-direction: column;\n  z-index: 998;\n}\n\n.label-info {\n  display: flex;\n  align-items: flex-start;\n}\n\n.input-element {\n  min-width: 100%;\n  position: relative;\n}\n\n.arrow-down, .arrow-up::before,\n.arrow-up {\n  cursor: pointer;\n}\n\n.arrow-down::before, .arrow-up::before {\n  content: \" \";\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  top: calc(50% - 3px);\n  right: 20px;\n  border: 1.5px solid;\n  transform: rotate(45deg) translateY(-50%);\n  border-color: transparent black black transparent;\n}\n\n.right-icon {\n  position: absolute;\n  right: 10px;\n  top: calc(50% - 14px);\n}\n.right-icon button {\n  background-color: transparent;\n  color: rgb(0, 116, 0);\n  font-size: 1.25rem;\n}\n.right-icon button:active {\n  transform: scale(0.9);\n}\n\n.arrow-up::before {\n  border-color: black transparent transparent black !important;\n}\n\n.select--text, .select--button {\n  box-sizing: border-box;\n  padding: 13px 32px 13px 16px;\n  background: #ffffff;\n  border: 1px solid #77777a;\n  border-radius: 8px;\n  width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\nul li {\n  list-style: none;\n  padding: 10px;\n  border-bottom: 1px solid;\n}\n\nul {\n  margin: 0;\n  padding: 0;\n}\n\n.drop-down--icon {\n  background: url(\"data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\") no-repeat;\n  background-position: calc(100% - 0.75rem) center !important;\n}\n\n.options {\n  border-radius: 4px;\n  margin-top: 10px;\n  background-color: #ffffff;\n  height: fit-content;\n  opacity: 0;\n  transition: transform 0.5s ease-in-out;\n  overflow-y: auto;\n  z-index: -999;\n  width: fit-content;\n  position: absolute;\n  display: none;\n  box-shadow: 0 2px 2px -3px rgba(0, 0, 0, 0.2), 0 6px 8px 1px rgba(0, 0, 0, 0.1411764706), 0 3px 12px 1px rgba(0, 0, 0, 0.1215686275);\n  max-height: 280px;\n}\n\n.options.active {\n  display: block;\n  z-index: 999;\n}\n\n.menu-active {\n  background-color: #f1f1f1;\n}\n\n.menu-focus {\n  background-color: transparent;\n}\n\n.options.not-hover {\n  position: static;\n}\n\n.arrow-up.not-hover::before {\n  top: calc(50% - 5px);\n}\n\n.input--select input:focus {\n  outline: none !important;\n  border: 1px solid #0040dd !important;\n  box-shadow: 0px 4px 4px rgba(179, 178, 177, 0.16) !important;\n}\n\n.asterisk {\n  color: rgb(142, 0, 0);\n  margin-left: 4px;\n  font-weight: 600;\n}\n\n#options::-webkit-scrollbar {\n  width: 8px;\n}\n#options::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: #71758a;\n}\n\n.caret-color--transparent {\n  caret-color: transparent;\n}\n\n.search--icon {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 20px;\n  cursor: pointer;\n}\n\n.select--button {\n  display: block;\n  height: 54px;\n  text-align: start;\n  font-size: 1rem;\n  vertical-align: middle;\n}\n.select--button::before {\n  content: attr(data-placeholder);\n  color: #71758a;\n}\n.select--button:disabled {\n  background-color: rgb(238, 238, 240);\n  cursor: not-allowed;\n  color: rgb(0, 0, 0);\n}\n\n.select--button:has(.indicator) {\n  display: flex;\n}\n\n.input-element:has(.select--button:disabled) .dropdown--icon {\n  cursor: not-allowed;\n}\n\n.custom-option {\n  padding: 0;\n}\n.custom-option button {\n  background-color: transparent;\n  color: rgb(0, 64, 221);\n  width: 100%;\n  padding: 10px;\n  margin: 0;\n}\n.custom-option:hover {\n  text-decoration: underline;\n}\n.custom-option input {\n  width: 100% !important;\n}\n\n.dropdown--overlay {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n  background-color: transparent;\n  z-index: 899;\n  overflow: hidden;\n}\n\n.indicator {\n  height: 10px;\n  width: 80px;\n  margin-left: 10px;\n  border-radius: 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
